const credit = resolve => require(['@/page/credit/index'], resolve);
export default [
  {
    path: '/credit',
    name: 'credit',
    component: credit,
    meta: {
      title: "信用"
    }
  }
]